import React, { Component } from 'react';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import TableRow from 'components/tables/tableRow';
import Input from 'components/forms/Input';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import debounce from 'lodash/debounce';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import NotificationSystem from 'rc-notification';
import LaunchConfirmationModal from 'components/modals/LaunchConfirmationModal';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { DEFAULT_CONTACT_QUERY_PARAMS } from 'constants/sequence';

import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import BasicNotification from 'components/Notification';
import { stripDecimalsAndFormat, calculatePercentage } from 'utils/misc';
import DestroyModal from 'components/modals/DestroyModal';
import { getSequenceContacts } from 'redux/actions/sequenceContactActions';
import { toggleDestroyModal } from 'redux/actions/destroyModalActions';
import Pagination from 'components/pagination/Pagination';
import { getSequences, updateSequence, destroySequence } from 'redux/actions/sequenceActions';
import SequenceCreate from 'containers/Sequences/SequenceCreate';
import withGotoSettingsModal from 'containers/Sequences/SequenceDetail/withGotoSettingsModal';
import NoResults from 'components/NoResults';
import WarningNotificationDialog from 'components/modals/WarningNotificationDialog';
import { sequenceTabUrl } from 'constants/routing';
import { Can, AbilityContext } from 'utils/permissions';
import { getBadgeStatus, STATUS_CHANGEABLE } from 'constants/campaign';
import StatusBadge from '../StatusBadge';
import CampaignStats from '../CampaignList/CampaignStats';

class SequencesTab extends Component {
  static propTypes = {
    getSequences: PropTypes.func.isRequired,
    toggleDestroyModal: PropTypes.func.isRequired,
    updateSequence: PropTypes.func.isRequired,
    destroySequence: PropTypes.func.isRequired,
    sequences: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      count: PropTypes.number,
      next: PropTypes.string,
      previous: PropTypes.string,
      results: PropTypes.array,
    }).isRequired,
    campaign: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      id: PropTypes.number,
      stat_people: PropTypes.number,
      stat_opens: PropTypes.number,
      stat_replies: PropTypes.number,
      stat_delivered: PropTypes.number,
      stat_unique_delivered: PropTypes.number,
      stat_unique_opens: PropTypes.number,
      stat_unique_replies: PropTypes.number,
      stat_interested: PropTypes.number,
      potential_reach: PropTypes.number,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    errors: PropTypes.shape({
      message: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
    getSequenceContacts: PropTypes.func.isRequired,
    sequenceContacts: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    toggleConfirmGoToSettingsModal: PropTypes.func,
  };

  static defaultProps = {
    toggleConfirmGoToSettingsModal: () => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      filterParams: {
        search: null,
      },
      isModalOpen: false,
      isConfirmOffModalOpen: false,
      sequence: null,
      warningOpen: false,
    };
    this.emitChangeDebounced = debounce(this.emitChange, 400);
  }

  componentDidMount() {
    this.props.getSequences(this.props.match.params.id);
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({ style: { zIndex: '9999' } }, n => this.notification = n);
  }

  componentWillUnmount() {
    this.emitChangeDebounced.cancel();
    this.notification.destroy();
  }

  static getSequenceCls(stepsSentProgress) {
    if (stepsSentProgress < 0.3) {
      return 'progress-bar progress-bar--light-blue';
    } else if (stepsSentProgress >= 0.3 && stepsSentProgress < 0.6) {
      return 'progress-bar progress-bar--bluer';
    }
    return 'progress-bar progress-bar--bluest';
  }

  onSuccessSequenceDestroyed = () => {
    this.props.toggleDestroyModal();
    this.props.getSequences(this.props.match.params.id);
  }

  toggle = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      sequence: !this.state.isModalOpen
        ? this.state.sequence
        : null,
    });
  }

  closeWarning = () => {
    this.setState({ warningOpen: false });
  }

  toggleIsConfirmOffModalOpen = (sequence) => {
    this.setState({
      isConfirmOffModalOpen: !this.state.isConfirmOffModalOpen,
      sequence,
    });
  }

  openModal = async (sequence) => {
    await this.props.getSequenceContacts(sequence.id, {
      ...DEFAULT_CONTACT_QUERY_PARAMS,
      exlude_self: true,
    });
    this.setState({ sequence }, this.toggle());
  }

  saveSequence = async (launch) => {
    this.setState({
      isModalOpen: false,
      isConfirmOffModalOpen: false,
    });
    try {
      await this.props.updateSequence(this.state.sequence.id, { status: launch }, true);
    } catch (error) {
      this.showNotification(error.errors.status);
    }
    // if (launch && this.state.sequence.variable_error) {
    //   this.setState({ warningOpen: true });
    // }
  }

  prepareDestroy = sequence => () => {
    this.props.toggleDestroyModal(sequence.id, sequence.name);
  };

  showNotification = (message) => {
    this.notification.notice({
      content: <BasicNotification
        color="danger"
        message={message}
      />,
      duration: 2,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  emitChange(value) {
    this.props.getSequences(this.props.match.params.id, { search: value });
    this.setState({ filterParams: { search: value } });
  }

  handleStatusChange = (value, sequence) => {
    if (value && sequence.launch_date) {
      this.openModal(sequence);
    } else if (value && !sequence.launch_date) {
      this.props.toggleConfirmGoToSettingsModal(sequence);
    } else {
      this.toggleIsConfirmOffModalOpen(sequence);
    }
  }

  render() {
    const { sequences, sequenceContacts } = this.props;
    const {
      filterParams, sequence, isModalOpen, isConfirmOffModalOpen, warningOpen,
    } = this.state;
    const isSequencesLoading = sequences.loading;
    const hasSequences = sequences.results && sequences.results.length >= 1;
    const sequenceName = sequence ? sequence.name : '';

    return (
      <Can I="see" a="Sequence">
        <React.Fragment>
          <div>
            <DestroyModal
              funcToExecute={this.props.destroySequence}
              onSuccess={this.onSuccessSequenceDestroyed}
              toggleDestroyModal={() => this.props.toggleDestroyModal()}
            />
          </div>
          <WarningNotificationDialog
            errorMessage={
              <>
                Your Campaign has been Scheduled to Launch.
                <br /><br />
                However, note it will not send to some contacts due to missing variables.
                Filter contacts by 'Status-Delivery' is 'Variable Error' to review.
              </>
            }
            isOpen={warningOpen}
            toggle={this.closeWarning}
          />
          <LaunchConfirmationModal
            isOpen={isModalOpen}
            toggle={this.toggle}
            launchDateTz={sequence ? sequence.launch_date_time_zone : null}
            launchDate={sequence ? sequence.launch_date : null}
            totalContacts={sequenceContacts.pending_contacts}
            onSave={this.saveSequence}
            onSaveLaunch={this.saveSequence}
          />
          <ConfirmationModal
            open={isConfirmOffModalOpen}
            onBackdropClick={() => this.toggleIsConfirmOffModalOpen(false)}
            title="Warning"
            confirmLabel="Accept"
            confirmBtnColor="primaryCTA"
            onConfirmClick={() => this.saveSequence(false)}
            onCancelClick={() => this.toggleIsConfirmOffModalOpen(false)}
          >
            <span>Are you sure you want to turn off <strong>&#34;{sequenceName}&#34;</strong>?</span>
            <br />It will continue to poll responses but stop sending emails for this sequence.
          </ConfirmationModal>
          <div className="d-flex flex-sm-row flex-column mt-2">
            <div className="search-input-form mr-2 w-100">
              <Input
                inputProps={{ type: 'search' }}
                rightIcon="search"
                onChange={e => this.emitChangeDebounced(e.target.value)}
                placeholder="Search"
              />
            </div>
            <Can I="create" a="Sequence">
              <div className="campaign-detail__add-sequence-btn">
                <SequenceCreate />
              </div>
            </Can>
          </div>

          <CampaignStats
            totalPeople={this.props.campaign.stat_people}
            totalDelivered={this.props.campaign.stat_unique_delivered}
            totalPeopleContacted={this.props.campaign.stat_unique_delivered}
            opensSum={this.props.campaign.stat_unique_opens}
            repliesSum={this.props.campaign.stat_unique_replies}
            potentialReachSum={this.props.campaign.potential_reach}
            interestedSum={this.props.campaign.stat_interested}
          />

          {(!isSequencesLoading && hasSequences) ?
            <React.Fragment>
              <Table size="sm" className="volt-table mt-3" responsive borderless>
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Progress</TableCell>
                    <TableCell>People</TableCell>
                    <TableCell>Open rate</TableCell>
                    <TableCell>Reply</TableCell>
                    <TableCell>Potential Reach</TableCell>
                    <TableCell>Delivered</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!this.props.sequences.loading &&
                    this.props.sequences.results.map(seq => (
                      <TableRow key={seq.id}>
                        <TableCell>
                          <Link to={sequenceTabUrl(seq.id)}>
                            {seq.name}
                          </Link>
                        </TableCell>
                        <TableCell>
                          <StatusBadge
                            status={getBadgeStatus(seq)}
                            handleStatusChange={
                              STATUS_CHANGEABLE.includes(getBadgeStatus(seq)) ?
                                arg => this.handleStatusChange(arg, seq) : null
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <div className="progress-wrap progress-wrap--middle">
                            <div className="progress">
                              <div
                                className={SequencesTab.getSequenceCls(seq.stat_progress)}
                                role="progressbar"
                                aria-valuenow={seq.stat_progress * 100}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: `${seq.stat_progress * 100}%` }}
                              />
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>{seq.stat_people}</TableCell>
                        <TableCell>
                          {
                            seq.stat_unique_opens !== 0 && seq.stat_unique_delivered !== 0 ?
                            `${calculatePercentage(seq.stat_unique_delivered, seq.stat_unique_opens)}%
                            (${seq.stat_unique_opens})` :
                            '-'
                          }
                        </TableCell>
                        <TableCell>
                          {
                            seq.stat_unique_replies !== 0 && seq.stat_unique_delivered !== 0 ?
                            `${calculatePercentage(seq.stat_unique_delivered, seq.stat_unique_replies)}%
                            (${seq.stat_unique_replies})` :
                            '-'
                          }
                        </TableCell>
                        <TableCell>
                          {
                            parseInt(seq.potential_reach, 10)
                              ? stripDecimalsAndFormat(seq.potential_reach)
                              : '-'
                          }
                        </TableCell>
                        <TableCell>
                          {
                            seq.stat_delivered !== 0 ?
                            seq.stat_delivered :
                            '-'
                          }
                        </TableCell>
                        <TableCell>
                          <Can I="delete" a="Sequence">
                            <DeleteOutlineIcon onClick={this.prepareDestroy(seq)} />
                          </Can>
                          <Link to={sequenceTabUrl(seq.id)}>
                            <DotsHorizontalIcon />
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
              <Pagination
                items={this.props.sequences}
                onChangePage={this.props.getSequences}
                params={filterParams}
                parentObjId={this.props.campaign.id}
              />
            </React.Fragment>
            :
            <NoResults
              className="mb-3"
              loading={isSequencesLoading}
              results={this.props.sequences}
            />
          }
        </React.Fragment>
      </Can>
    );
  }
}

SequencesTab.contextType = AbilityContext;


export default compose(
  withNamespaces('common'),
  withGotoSettingsModal,
  connect(
    state => ({
      campaign: state.campaign,
      sequences: state.sequences,
      errors: state.errors,
      sequenceContacts: state.sequenceContacts,
    }),
    {
      getSequences,
      toggleDestroyModal,
      updateSequence,
      destroySequence,
      getSequenceContacts,
    },
  ),
)(SequencesTab);
